require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./bharat-ki-sehr.json") })
        }
      }, "path---bharat-ki-sehr");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---bharat-ki-sehr!./.cache/json/bharat-ki-sehr.json
// module id = 707
// module chunks = 231608221292675